import React, { useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import InputForm from "../../InputT";
import SearInputG from "../../SearchInput";
import CheckBox from "../../CheckBox";
import SearchModal from '../../SearchModal';
import ParamsPicklist from '../../../Types/ParamsPicklist';

// Configurations des Picklists
const searchPoint: ParamsPicklist = { CodeAgence: '', Table: "PointStockage", Colonne1: "CodePoint", Colonne2: "Libelle", Colagence: '101', Choix: 22 };
const searchVille: ParamsPicklist = { CodeAgence: '', Table: "CdVille", Colonne1: "CdVille", Colonne2: "Libell", Colagence: '001', Choix: 22 };
const searchPays: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '', colfiltre:'RUBRIQ', valfiltre:'PAYS', Choix: 22 };

const Tab1 = (props: {
  form?: any,
  EtatG: boolean,
  disabledForm: boolean,
  sbmit: string
}) => {

  return (
    <div className='tabItemAuto'>
      <div>
        <Grid container className='border' sx={{ width: "85%", position: "absolute" }}>
          
          {/* --- COLONNE GAUCHE : IDENTIFICATION & GÉOGRAPHIE --- */}
          <Grid item xs={12} md={6} lg={6} className='border-left'>
            <legend>Identification & Localisation Geographique</legend>
            
            <Box sx={{ pointerEvents: props.sbmit === 'add' ? 'none' : 'auto' }}>
              <SearchModal 
                width={6} 
                disabled={props.EtatG} 
                notRequired 
                form={props.form} 
                Titre={'Recherche Point'} 
                label={'Point de stockage'} 
                name={'CODEPOINT'} 
                Parametre={searchPoint} 
              />
            </Box>

            <InputForm 
              width={6} 
              label="Libellé" 
              type="texte" 
              name="LIBELLE" 
              disabled={props.disabledForm} 
            />

            <InputForm 
              width={6} 
              label="Adresse" 
              type="TextArea" 
              name="ADDRESS" 
              disabled={props.disabledForm} 
              row={2} 
            />

            <SearInputG 
              width={6} 
              form={props.form} 
              Titre={'Recherche Pays'} 
              label={'Pays'} 
              name={'CODEPAYS'} 
              Parametre={searchPays} 
              dissabledCode={props.disabledForm} 
            />

            <SearInputG 
              width={6} 
              form={props.form} 
              Titre={'Recherche Ville'} 
              label={'Ville'} 
              name={'CODEVILLE'} 
              Parametre={searchVille} 
              dissabledCode={props.disabledForm} 
            />

            <InputForm
              width={6}   
              label="Boite Postal" 
              type="texte"
              name="CODEPOSTAL"  
              disabled={props.disabledForm} 
            />
          </Grid>

          {/* --- COLONNE DROITE : CONFIGURATION & AUDIT --- */}
          <Grid item xs={12} md={6} lg={6} className='border-left'>
            <legend>Détails Techniques</legend>

            <InputForm 
              width={7} 
              label="Capacité (Tonnes)" 
              type="number" 
              money
              name="CAPACITESTOCKAGE" 
              disabled={props.disabledForm} 
            />


            <Box sx={{ ml: "2%", mb: 2, display: 'flex', gap: 3 }}>
              <CheckBox notRequired form={props.form} label="Proprietaire" name="ESTPROPRE" disabled={props.disabledForm} />
              <CheckBox notRequired form={props.form} label="Assuré" name="ESTASSURE" disabled={props.disabledForm} />
              <CheckBox notRequired form={props.form} label="Actif" name="ISACTIVE" disabled={props.disabledForm} />
            </Box>

            <legend>Traçabilité & Audit</legend>

            <InputForm 
              width={7} 
              notRequired
              label="Créé par" 
              name="CREATEDBY" 
              type='text' 
              disabled={true} 
            />

            <InputForm 
              width={7} 
              notRequired
              label="Date Création" 
              name="DATECREATION" 
              type='text' 
              disabled={true} 
            />

            <InputForm 
              width={7} 
              notRequired
              label="Modifié par" 
              name="UPDATEDBY" 
              type='text' 
              disabled={true} 
            />

            <InputForm 
              width={7} 
              notRequired
              label="Date Modif." 
              name="DATEMODIFICATION" 
              type='text' 
              disabled={true} 
            />

            <InputForm 
              width={7}
              label="Commentaire" 
              name="COMMENTAIRE" 
              type='TextArea'  
              disabled={props.disabledForm} 
              row={2}
            />
          </Grid>

        </Grid>
      </div>
    </div>
  );
}

export default Tab1;